import axios from '@/axios'

axios.defaults.baseURL = process.env.VUE_APP_MYPAGE_URL

export default axios
